import { safeParse } from "@/utils/safeParse";
export default function board(set) {
  return {
    listCacheMap: undefined,
    setListCacheMap(data) {
      set({
        listCacheMap: safeParse(data),
      });
    },
  };
}
